module.exports = __webpack_public_path__ + "static/media/Bank Info Illustration.31053d8a.svg";